/* eslint-disable linebreak-style */
import React from 'react';
import Link from 'next/link';
import BaseUiLink from 'base-ui/dist/NavLink';

// TODO: temporary approach to fix https://www.wrike.com/open.htm?id=556519222
const NavLink = (props) => (
  <BaseUiLink
    {...props}
    LinkProp={Link}
  />
);

export default NavLink;
